<template>
	<section id="tour_details_main" class="section_padding">
		<div class="container">
			<div class="row">
				<div class="col-lg-9 col-md-12 col-sm-12 offset-lg-1">

					<div class="tour_details_leftside_wrapper">
						<div class="tour_details_heading_wrapper">
							<div class="tour_details_top_heading">
								<h2>{{ property.propertyInfo?.name }}</h2>
								<strong class="text-primary"> {{ property.propertyInfo?.address }} - </strong>
								<a :href="`https://www.google.com/maps/search/?api=1&query=${property.propertyInfo?.latitude},${property.propertyInfo?.longitude}`"
									target="_blank" rel="noopener">
									{{ $t("view_on_map") }}
									<i class="fas fa-map-marker-alt text-danger"></i>
								</a>
							</div>
						</div>

						<div class="tour_details_img_wrapper">
							<div class="row">
								<div class="col-lg-10 col-md-12 col-sm-12">
									<div class="image__gallery">
										<div class="gallery">
											<div class="gallery__slideshow">
												<div class="gallery__slides">
													<div class="gallery__slide" v-for="(slide, index) in gallerySlides"
														:key="index"
														:class="{ 'gallery__slide--active': slideIndex === index }">
														<img class="gallery__img" :src="slide.img.uri"
															:alt="property?.propertyInfo?.name || ''" />
													</div>
												</div>
												<a @click.prevent="move(-1)" class="gallery__prev">&#10095;</a>
												<a @click.prevent="move(1)" class="gallery__next">&#10094;</a>
											</div>

											<div class="gallery__content">
												<div class="gallery__items">
													<div class="gallery__item"
														:class="{ 'gallery__item--is-acitve': slideIndex === index }"
														v-for="(slide, index) in gallerySlides" :key="`item-${index}`">
														<img :src="slide.img.uri" @click="currentSlide(index)"
															class="gallery__item-img" />
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="row mt-3">
								<div class="col-12">
									<videos :list-videos="property?.videos ? Object.values(property.videos) : []">
									</videos>
								</div>
							</div>

							<div class="tour_details_boxed">
								<h3 class="heading_theme">{{ $t("general_description") }}</h3>
								<div class="tour_details_boxed_inner" v-html="property?.remarks">
								</div>
								<div class="tour_package_details_bar_list">
									<h5>{{ $t("property_amenities") }}</h5>
									<div class="row">
										<div class="col-lg-6 col-md-6 col-sm-12 col-12">
											<ul>
												<li v-for="(amenity, index) in firstHalf" :key="'first-' + index">
													<i class="fas fa-check"></i> {{ amenity.name }}
												</li>
											</ul>
										</div>
										<div class="col-lg-6 col-md-6 col-sm-12 col-12">
											<ul>
												<li v-for="(amenity, index) in secondHalf" :key="'second-' + index">
													<i class="fas fa-check"></i> {{ amenity.name }}
												</li>
											</ul>
										</div>
									</div>
								</div>

								<div class="tour_package_details_bar_list">
									<h5>{{ $t("policies") }}</h5>
									<div v-html="property.polices"></div>
								</div>
							</div>

							<div class="tour_details_boxed">
								<strong>Check In:</strong> <small>{{ property.check_in }}</small><br>
								<strong>Check Out:</strong> <small>{{ property.check_out }}</small>
							</div>

							<div class="tour_details_boxed">
								<h3 class="heading_theme">{{ $t("availability") }}</h3>

								<div v-if="property.channels" class="room_select_area">
									<ul class="nav nav-tabs" id="myTab" role="tablist">
										<li class="nav-item" role="presentation">
											<h4>{{ $t("book_with_us") }}</h4>
										</li>
									</ul>

									<div class="tab-content" id="myTabContent">
										<div class="tab-pane fade show active" id="home" role="tabpanel"
											aria-labelledby="home-tab">
											<div class="room_booking_area">
												<div class="tour_search_form">
													<!-- ---------- FORM (validate first) ---------- -->
													<form @submit.prevent="handleSubmit">
														<div class="row">
															<!-- Dates -->
															<div class="col-lg-6 col-md-4 col-sm-12 col-12">
																<div class="flight_Search_boxed py-3 date_flex_area">
																	<div class=" w-100">
																		<p>{{ $t("dates_of_stay") }}</p>
																		<flat-pickr ref="datesField"
																			v-model="selectedDates" :config="dateConfig"
																			:placeholder="$t('entry_date') + ' - ' + $t('departure_date')"
																			class="w-100"
																			:class="{ 'is-invalid': !!formErrors.dates }"
																			@onChange="handleDateChange" />
																		<div v-if="formErrors.dates"
																			class="invalid-feedback d-block">
																			{{ formErrors.dates }}
																		</div>
																	</div>
																</div>

															</div>

															<div class="col-lg-4 col-md-6 col-sm-12 col-12">
																<CountDropdownHotel
																	:props_nationality="customerNationality"
																	:props_guests="props_guests"
																	@updateGuests="handleUpdateGuests"
																	@updatecustomerNationality="setcustomerNationality"
																	:errors="formErrors" />
															</div>

															<div class="col-lg-2 col-md-2 col-sm-12 col-12">
																<button type="submit"
																	:class="['btn', 'search-button', 'btn_theme', 'd-flex', 'align-items-center', 'justify-content-center', 'flight_Search_boxed', 'w-100']"
																	:disabled="isLoading">
																	{{ $t('search') }}
																	<i v-if="!isLoading"
																		class="px-2 fas fa-angle-right text-coral"></i>
																	<div v-else class="loader"></div>
																</button>
															</div>
														</div>
													</form>

												</div>

												<div>
													<br />
													<!-- Empty state -->
													<div v-if="!property.rooms || property.rooms.length === 0"
														class="card border-0 bg-light p-4 my-4">
														<h4 class="mb-2">{{ $t('no_availability_title') }}</h4>
														<p class="mb-3">
															{{ $t('no_availability_desc', {
																start: startFmt, end:
																	endFmt, guests: guestsSummary
															}) }}
														</p>
														<ul class="mb-0">
															<li>{{ $t('no_availability_suggest_dates') }}</li>
															<li>{{ $t('no_availability_suggest_guests') }}</li>
															<li>{{ $t('no_availability_suggest_nearby') }}</li>
														</ul>
													</div>

													<div v-if="property.rooms && property.rooms.length"
														class="reserve-sticky shadow-sm">
														<div
															class="d-flex align-items-center justify-content-end gap-2">
															<button class="btn btn-primary btn-lg"
																@click="handleReservationClick">
																{{ $t("i_will_reserve") }}
															</button>
														</div>
													</div>

													<!-- DESKTOP/TABLET -->
													<div v-if="property.rooms && property.rooms.length > 0"
														class="d-none d-md-block">
														<div class="table-responsive">
															<table class="table table-hover align-middle">
																<thead class="table-light">
																	<tr>
																		<th class="text-center">{{ $t("room_type") }}
																		</th>
																		<th class="text-center">{{
																			$t("number_of_people") }}</th>
																		<th class="text-center">{{ $t("price") }}</th>
																		<th class="text-center">{{ $t("your_options") }}
																		</th>
																		<th class="text-center">{{ $t("select_rooms") }}
																		</th>
																	</tr>
																</thead>
																<tbody>
																	<tr v-for="(room, index) in property.rooms"
																		:key="room.roomId">
																		<td class="text-center">
																			{{ room.roomName }}<br />
																			<small v-if="room.images?.length > 0"
																				@click="openModal(room)"
																				class="text-muted text-decoration-underline"
																				style="cursor:pointer">
																				{{ $t('show_photos') }}
																			</small>
																		</td>
																		<td>
																			<ul
																				class="list-prices center-data list-unstyled mb-0">
																				<li v-for="ratePlan in room.ratePlans"
																					:key="ratePlan.id + '-occ'">
																					<div v-if="ratePlan.occupancy > 0">
																						<i class="fa fa-user"></i> x {{
																							ratePlan.occupancy }}
																					</div>
																					<div v-else>
																						<i v-for="(adults, i) in room.searchedPax.adults"
																							:key="'a' + i"
																							class="fa fa-user"></i>
																						<i v-for="(children, i) in room.searchedPax.children"
																							:key="'c' + i"
																							class="fa fa-user"
																							style="font-size:12px; margin-left:4px;"></i>
																					</div>
																				</li>
																			</ul>
																		</td>
																		<td>
																			<ul
																				class="list-prices center-data list-unstyled mb-0">
																				<li v-for="ratePlan in room.ratePlans"
																					:key="ratePlan.id + '-price'">
																					{{
																						formatNumber(ratePlan.payment.chargeAmount.total)
																					}}
																					{{
																						ratePlan.payment.chargeAmount.currency
																					}}<br />
																					<span class="badge bg-success"
																						v-if="ratePlan.payment.chargeAmount?.promotion?.percentaje">
																						- {{
																							ratePlan.payment.chargeAmount?.promotion?.percentaje
																						}} %
																					</span>
																					<div
																						v-if="ratePlan.payment.taxesFeesAdd.length">
																						<div v-for="taxFee in ratePlan.payment.taxesFeesAdd"
																							:key="'add' + taxFee.Total">
																							+ {{ taxFee.Total }} {{
																								$t("additional_taxes") }}
																						</div>
																					</div>
																					<div
																						v-if="ratePlan.payment.taxesFeesDisplay.length">
																						<div v-for="taxFee in ratePlan.payment.taxesFeesDisplay"
																							:key="'dis' + taxFee.Total">
																							+ {{
																								taxFee.Total.toLocaleString('es-ES',
																									{
																										minimumFractionDigits: 2
																									}) }}
																							{{
																								ratePlan.payment.chargeAmount.currency
																							}} {{
																								$t("local_taxes_and_charges")
																							}}
																						</div>
																					</div>
																				</li>
																			</ul>
																		</td>
																		<td>
																			<ul
																				class="list-prices center-data list-unstyled mb-0">
																				<li v-for="ratePlan in room.ratePlans"
																					:key="ratePlan.id + '-opts'">
																					<div v-for="option in ratePlan.options"
																						:key="option.title">
																						{{ option.title }}<br />
																						{{ option.text }}
																					</div>
																				</li>
																			</ul>
																		</td>
																		<td>
																			<ul
																				class="list-prices center-data list-unstyled mb-0">
																				<li v-for="(ratePlan, ratePlanIndex) in room.ratePlans"
																					:key="ratePlan.id + '-sel'">
																					<select class="form-select"
																						v-model="selectedOptions[index][ratePlanIndex]">
																						<option value="0" selected>0
																						</option>
																						<option
																							v-for="n in room.numberOfAvailableRooms"
																							:key="n" :value="n"
																							:disabled="validateDisabledOptions(index, ratePlanIndex, n)">
																							{{ n }} {{
																								ratePlan.payment.chargeAmount.currency
																							}}
																							{{ (n *
																								ratePlan.payment.chargeAmount.total).toLocaleString('es-ES',
																									{
																										minimumFractionDigits: 2
																									}) }}
																						</option>
																					</select>
																				</li>
																			</ul>
																		</td>
																	</tr>
																</tbody>
															</table>
														</div>
													</div>

													<!-- MOBILE -->
													<div v-if="property.rooms && property.rooms.length > 0"
														class="d-block d-md-none">
														<div v-for="(room, index) in property.rooms"
															:key="'m-' + room.roomId" class="card mb-3 shadow-sm">
															<div class="card-body">
																<div
																	class="d-flex justify-content-between align-items-center mb-2">
																	<h5 class="mb-0">{{ room.roomName }}</h5>
																	<small v-if="room.images?.length"
																		@click="openModal(room)"
																		class="text-muted text-decoration-underline"
																		style="cursor:pointer">
																		{{ $t('show_photos') }}
																	</small>
																</div>

																<div v-for="(ratePlan, ratePlanIndex) in room.ratePlans"
																	:key="'m-rp-' + ratePlan.id"
																	class="border rounded p-2 mb-2">
																	<div
																		class="d-flex justify-content-between align-items-start">
																		<div class="small">
																			<span v-if="ratePlan.occupancy > 0">
																				<i class="fa fa-user"></i> x {{
																					ratePlan.occupancy }}
																			</span>
																			<span v-else>
																				<i v-for="(adults, i) in room.searchedPax.adults"
																					:key="'ma' + i"
																					class="fa fa-user"></i>
																				<i v-for="(children, i) in room.searchedPax.children"
																					:key="'mc' + i" class="fa fa-user"
																					style="font-size:12px; margin-left:4px;"></i>
																			</span>
																		</div>
																		<div class="text-end">
																			<div class="fw-semibold">
																				{{
																					formatNumber(ratePlan.payment.chargeAmount.total)
																				}}
																				{{
																					ratePlan.payment.chargeAmount.currency
																				}}
																			</div>
																			<span class="badge bg-success"
																				v-if="ratePlan.payment.chargeAmount?.promotion?.percentaje">
																				- {{
																					ratePlan.payment.chargeAmount?.promotion?.percentaje
																				}} %
																			</span>
																		</div>
																	</div>

																	<div class="mt-1 small text-muted"
																		v-if="ratePlan.payment.taxesFeesAdd.length || ratePlan.payment.taxesFeesDisplay.length">
																		<div v-for="taxFee in ratePlan.payment.taxesFeesAdd"
																			:key="'m-add' + taxFee.Total">
																			+ {{ taxFee.Total }} {{
																				$t("additional_taxes") }}
																		</div>
																		<div v-for="taxFee in ratePlan.payment.taxesFeesDisplay"
																			:key="'m-dis' + taxFee.Total">
																			+ {{ taxFee.Total.toLocaleString('es-ES', {
																				minimumFractionDigits: 2
																			}) }}
																			{{ ratePlan.payment.chargeAmount.currency }}
																			{{ $t("local_taxes_and_charges") }}
																		</div>
																	</div>

																	<div class="mt-2"
																		v-if="ratePlan.options && ratePlan.options.length">
																		<div v-for="option in ratePlan.options"
																			:key="'m-opt-' + option.title">
																			<div class="fw-semibold">{{ option.title }}
																			</div>
																			<div class="small text-muted">{{ option.text
																			}}</div>
																		</div>
																	</div>

																	<div class="mt-2">
																		<label class="form-label small mb-1">{{
																			$t("select_rooms") }}</label>
																		<select class="form-select"
																			v-model="selectedOptions[index][ratePlanIndex]">
																			<option value="0" selected>0</option>
																			<option
																				v-for="n in room.numberOfAvailableRooms"
																				:key="'m-n' + n" :value="n"
																				:disabled="validateDisabledOptions(index, ratePlanIndex, n)">
																				{{ n }} {{
																					ratePlan.payment.chargeAmount.currency
																				}}
																				{{ (n *
																					ratePlan.payment.chargeAmount.total).toLocaleString('es-ES',
																						{
																							minimumFractionDigits: 2
																						}) }}
																			</option>
																		</select>
																	</div>
																</div>
															</div>
														</div>
													</div>

												</div>
											</div>
										</div>
									</div>
							</div>
							<div v-else class="card text-center border-0 bg-light p-4 my-4">
									<h4 class="mb-2">{{ $t('channels.noBookingTitle') }}</h4>
									<p class="mb-3">
										{{ $t('channels.noBookingMessage') }}
									</p>
								</div>
							</div>

							<Comments v-if="propertyKey == 'chn'" :key="propertyId" :model-id="propertyId"
								:model-type="'property'" />
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Modal Photos -->
		<div v-if="showModal" class="modal-overlay" @click.self="closeModal" role="dialog" aria-modal="true">
			<div class="modal-content position-relative " ref="modalContent">
				<div class="modal-header m-lg-4 m-sm-0">
					<h4 class="m-2">{{ selectedItem.roomName }}</h4>
					<a class="close-btn position-absolute rounded-2 mt-1 top-0 px-2 end-0 mx-3"
						@click="closeModal">x</a>
				</div>
				<div class="modal-body mx-lg-4 mx-sm-0">
					<div v-if="selectedItem">
						<swiper :loop="true" :navigation="true" :autoplay="{ delay: 3000, disableOnInteraction: false }"
							class="swiper-modal">
							<swiper-slide v-for="(image, index) in selectedItem.images" :key="index">
								<img :src="image.uri" :key="image.id" class="swiper-slide-modal" />
							</swiper-slide>
						</swiper>

						<h4 class="my-4">{{ $t('amenities') }}</h4>
						<ul class="mx-1 mx-md-4 list-unstyled">
							<div class="row g-2">
								<div class="col-6 col-md-4 col-lg-3" v-for="(amenity, index) in selectedItem.facilities"
									:key="index">
									<li><i class="fas fa-check"></i> {{ amenity.name }}</li>
								</div>
							</div>
						</ul>

						<div v-if="selectedItem.descriptions">
							<h4 class="my-2">{{ $t('description') }}</h4>
							<p class="mx-1 mx-md-4">{{ selectedItem.descriptions }}</p>
						</div>
					</div>
				</div>
			</div>
		</div>

	</section>
</template>

<script>
/* All code comments are in English as requested. */
import { Swiper, SwiperSlide } from "swiper/vue";
import CountDropdownHotel from "@/components/hotel/CountDropdownHotel.vue";
import axios from "axios";
import { mapState, mapActions } from "vuex";
import { API_BASE_URL, PROPERTY_API } from "@/api-config";
import FlatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Spanish } from "flatpickr/dist/l10n/es.js";
import "swiper/swiper-bundle.css";
import Swal from "sweetalert2";
import { generateShortId } from '@/utils/global';
import Comments from '@/components/comment/comment.vue'
import Videos from '@/components/video/videos.vue'

export default {
	name: "HotelSearch",
	components: {
		CountDropdownHotel,
		Swiper,
		SwiperSlide,
		FlatPickr,
		Comments,
		Videos
	},
	props: {
		props_guests: {
			type: Array,
			default: null,
		},
	},
	data() {
		return {
			formErrors: {
				dates: null,
				guests: null,
				nationality: null,
			},
			national: {},
			guests: [],
			active: false,
			start_date: "",
			end_date: "",
			key: "",
			selectedRoomType: { roomName: String, images: [] },
			roomTypes: [],
			gallerySlides: [],
			slideIndex: 0,
			slides: [],
			property: {},
			amenities: [],
			customWidth: 480,
			customHeight: 240,
			selectedRooms: [],
			selectedOptions: [],
			customerNationality: "",
			isLoading: false,
			selectedDates: [],
			dateConfig: {
				locale: Spanish,
				mode: "range",
				minDate: "today",
				showMonths: 1,
				formatDate: (date) => date.toISOString().slice(0, 10),
				defaultDate: this?.selectedDates || [],
			},
			propertyId: this.$route.params.id ?? 0,
			propertyKey: this.$route.params.key ?? 0,
			showModal: false,
			selectedItem: null
		};
	},

	mounted() {
		this.start_date = this.$route.query.start_date;
		this.end_date = this.$route.query.end_date;
		this.guests = this.$route.query.guests;
		this.fetchProperty();
		if (this.property && this.property.rooms) {
			this.initializeSelectedOptions();
		}
		this.customerNationality = this.$route.query.customerNationality;
		if (this.$route.query.start_date && this.$route.query.end_date) {
			this.selectedDates = [this.$route.query.start_date, this.$route.query.end_date];
		}
	},

	computed: {
		...mapState({
			adults: (state) => state.form.adults,
			children: (state) => state.form.children,
		}),
		hasSelectedRooms() {
			return this.selectedOptions.some((roomOptions) =>
				roomOptions.some((quantity) => quantity > 0)
			);
		},
		firstHalf() {
			return this.amenities.slice(0, Math.ceil(this.amenities.length / 2));
		},
		secondHalf() {
			return this.amenities.slice(Math.ceil(this.amenities.length / 2));
		},
		startFmt() {
			const d = this.$route.query.start_date;
			return this.formatDate(d);
		},
		endFmt() {
			const d = this.$route.query.end_date;
			return this.formatDate(d);
		},
		totalGuests() {
			const guestss = JSON.parse(this.$route.query.guests || "[]");
			if (Array.isArray(guestss)) {
				return guestss.reduce((acc, g) => acc + g.adults + (g.childrens?.length || 0), 0);
			}
			return Number(this.$route.query.guests_total || 0);
		},
		guestsInfo() {
			return this.parseGuests(this.$route.query.guests);
		},
		guestsSummary() {
			const { totalAdults, totalChildren } = this.guestsInfo;
			const total = totalAdults + totalChildren;
			return `${total} ${this.$tc('guest', total)} (${totalAdults} ${this.$tc('adult', totalAdults)}, ${totalChildren} ${this.$tc('child', totalChildren)})`;
		}
	},

	watch: {
		start_date() { if (this.formErrors.dates) this.formErrors.dates = null; },
		end_date() { if (this.formErrors.dates) this.formErrors.dates = null; },
		guests() { if (this.formErrors.guests) this.formErrors.guests = null; },
		national() { if (this.formErrors.nationality) this.formErrors.nationality = null; },
	},

	methods: {
		...mapActions("form", ["updateCapacity", "updateGuests", "updateError"]),

		// ---------- Validation helpers ----------
		resetFormErrors() {
			this.formErrors = { dates: null, guests: null, nationality: null };
		},
		validateForm() {
			this.resetFormErrors();
			let ok = true;

			if (!this.start_date || !this.end_date) {
				this.formErrors.dates = this.$t?.('dates_required');
				ok = false;
			}

			let groups = [];
			if (Array.isArray(this.guests)) {
				groups = this.guests;
			} else if (typeof this.guests === 'string') {
				const parsed = this.parseGuests(this.guests);
				groups = parsed?.groups || [];
			}
			const totalAdults = groups.reduce((n, g) => n + (Number(g.adults) || 0), 0);
			const totalChildren = groups.reduce((n, g) => n + (Array.isArray(g.children) ? g.children.length : 0), 0);

			if (!groups.length || (totalAdults + totalChildren) === 0) {
				this.formErrors.guests = this.$t?.('guests_required');
				ok = false;
			}

			const nationalitySlug = this.national?.slug;

			if (!nationalitySlug) {
				this.formErrors.nationality = this.$t?.('nationality_required');
				ok = false;
			}

			return ok;
		},
		scrollToFirstError() {
			if (this.formErrors.dates && this.$refs.datesField) {
				const el = this.$refs.datesField.$el || this.$refs.datesField;
				el?.scrollIntoView({ behavior: 'smooth', block: 'center' });
				return;
			}
			if ((this.formErrors.guests || this.formErrors.nationality) && this.$refs.guestsField) {
				this.$refs.guestsField.scrollIntoView({ behavior: 'smooth', block: 'center' });
			}
		},
		async handleSubmit() {
			if (!this.validateForm()) {
				this.scrollToFirstError();
				return;
			}
			try {
				this.isLoading = true;
				await this.refetchProperty();
			} finally {
				this.isLoading = false;
			}
		},
		// ---------- /Validation helpers ----------

		handleUpdateGuests(guestData) {
			this.guests = guestData;
		},
		formatDate(iso) {
			if (!iso) return '';
			return new Intl.DateTimeFormat('es-ES', { day: '2-digit', month: 'short', year: 'numeric' }).format(new Date(iso));
		},
		parseGuests(input) {
			if (!input) return { rooms: 0, groups: [], totalAdults: 0, totalChildren: 0 };
			const values = Array.isArray(input) ? input : [String(input)];
			const groups = values
				.flatMap(v => decodeURIComponent(v).split('&'))
				.map(s => {
					const a = s.match(/adults=\[(\d+)\]/);
					const c = s.match(/children=\[([\d,]*)\]/);
					const adults = a ? Number(a[1]) : 0;
					const children = c && c[1] ? c[1].split(',').filter(Boolean).map(Number) : [];
					return { adults, children };
				})
				.filter(g => g.adults || g.children.length);
			const totalAdults = groups.reduce((n, g) => n + g.adults, 0);
			const totalChildren = groups.reduce((n, g) => n + g.children.length, 0);
			return { rooms: groups.length, groups, totalAdults, totalChildren };
		},
		setcustomerNationality(customerNationality) {
			this.national = customerNationality;
		},
		handleDateChange(selectedDates) {
			if (selectedDates.length === 2) {
				const toYmd = (date) => {
					const d = new Date(date);
					const y = d.getFullYear();
					const m = String(d.getMonth() + 1).padStart(2, "0");
					const day = String(d.getDate()).padStart(2, "0");
					return `${y}-${m}-${day}`;
				};
				this.start_date = toYmd(selectedDates[0]);
				this.end_date = toYmd(selectedDates[1]);
			} else {
				this.start_date = "";
				this.end_date = "";
			}
		},

		handleReservationClick() {
			if (!this.hasSelectedRooms) {
				this.showAlert(this.$t("please_select_at_least_one_room"));
				return;
			}
			const token = generateShortId();
			const EXPIRATION_MINUTES = 30;
			const bookingData = {
				propertyName: this.property.propertyInfo.name,
				propertyContact: this.property.contact,
				start_date: this.start_date,
				end_date: this.end_date,
				rooms: this.getSelectedRooms(),
				customerNationality: this.$route.query.customerNationality,
				__expiresAt: Date.now() + EXPIRATION_MINUTES * 60 * 1000
			};
			localStorage.setItem(`booking_${token}`, JSON.stringify(bookingData));
			this.$router.push({
				name: "room-booking",
				params: { id: this.property.propertyId },
				query: { key: this.$route.params.key, token }
			});
		},

		showAlert(errorMessage) {
			Swal.fire({ icon: "error", title: "Error", text: errorMessage })
				.then(() => this.updateError({ status: false, message: "" }));
		},

		openModal(roomType) {
			this.selectedItem = roomType;
			this.showModal = roomType.images?.length > 0;
			document.body.style.overflow = 'hidden';
		},
		closeModal() {
			this.showModal = false;
			this.selectedItem = null;
			document.body.style.overflow = '';
		},

		move(n) {
			if (this.gallerySlides.length <= this.slideIndex + n) {
				this.slideIndex = 0;
			} else if (this.slideIndex + n < 0) {
				this.slideIndex = this.gallerySlides.length - 1;
			} else {
				this.slideIndex += n;
			}
		},
		currentSlide(index) {
			this.slideIndex = index;
		},

		initializeSelectedOptions() {
			this.selectedOptions = this.property.rooms.map((room) => room.ratePlans.map(() => 0));
		},

		async fetchPropertyData(key, id, params) {
			const { data } = await axios.get(`${API_BASE_URL}${PROPERTY_API}${key}/${id}`, { params });
			return data[0];
		},

		async fetchProperty() {
			try {
				const params = this.prepareParams();
				const data = await this.fetchPropertyData(this.$route.params.key, this.$route.params.id, params);
				this.processPropertyData(data);
			} catch (error) {
				this.handleError(error);
			}
		},

		async refetchProperty(newGuests) {
			this.isLoading = true;
			try {
				if (newGuests) this.guests = newGuests;
				const params = this.prepareParams();
				const data = await this.fetchPropertyData(this.$route.params.key, this.$route.params.id, params);
				this.processPropertyData(data);

				const serializeGuests = (guestsArray) => {
					if (!Array.isArray(guestsArray)) return "";
					return guestsArray
						.map(guest => `adults=[${guest.adults}],children=[${guest.children.join(",")}]`)
						.join("&");
				};

				const serializedGuests = Array.isArray(this.guests) ? serializeGuests(this.guests) : this.guests;



				this.$router.push({
					name: "hotel-details",
					params: { key: this.$route.params.key, id: this.$route.params.id },
					query: {
						start_date: this.start_date,
						end_date: this.end_date,
						guests: serializedGuests,
						rooms: this.guests.length,
						customerNationality: this.$route.query.customerNationality,
					},
				});
			} catch (error) {
				this.handleError(error);
			} finally {
				this.isLoading = false;
			}
		},

		prepareParams() {
			const deserializeGuests = (guestsInput) => {
				if (Array.isArray(guestsInput)) return guestsInput;
				if (typeof guestsInput === "string") {
					return guestsInput.split("&").map((guest) => {
						const adultsMatch = guest.match(/adults=\[(\d+)\]/);
						const childrenMatch = guest.match(/children=\[([\d,]*)\]/);
						return {
							adults: adultsMatch ? parseInt(adultsMatch[1], 10) : 0,
							children: childrenMatch && childrenMatch[1] ? childrenMatch[1].split(",").map(Number) : [],
						};
					});
				}
				throw new TypeError("guestsInput must be a string or an array.");
			};

			const guestsArray = deserializeGuests(this.guests);

			if (this.national?.slug !== undefined && this.$route.query.customerNationality != this.national?.slug) {
				this.$router.replace({
					query: { ...this.$route.query, customerNationality: this.national?.slug }
				});
			}

			return {
				start_date: this.start_date,
				end_date: this.end_date,
				guests: guestsArray,
				rooms: guestsArray.length,
				customerNationality: this.national?.slug ?? this.$route.query.customerNationality,
			};
		},

		processPropertyData(data) {
			this.property = data;
			this.gallerySlides = data.images.map((image) => ({ img: image }));
			this.roomTypes = data.rooms;
			this.amenities = data.facilities;
			this.initializeSelectedOptions();
		},

		handleError(error) {
			if (error?.response?.data?.message) {
				this.showAlert(error.response.data.message);
			} else {
				this.showAlert("Error desconocido");
			}
		},

		validateDisabledOptions(roomIndex, ratePlanIndex, value) {
			const room = this.property.rooms[roomIndex];
			const selectedQuantities = this.selectedOptions[roomIndex] || [];
			const currentSelection = Number(selectedQuantities[ratePlanIndex] || 0);
			const totalSelected = selectedQuantities.reduce((total, qty) => total + Number(qty || 0), 0);
			const availableForRatePlan = room.numberOfAvailableRooms - (totalSelected - currentSelection);
			return Number(value) > Math.max(availableForRatePlan, 0);
		},

		formatNumber(number) {
			return new Intl.NumberFormat("es-ES", {
				style: "decimal",
				minimumFractionDigits: 0,
				maximumFractionDigits: 2,
				useGrouping: true,
			}).format(number);
		},

		getSelectedRooms() {
			const selectedRooms = [];
			this.property.rooms.forEach((room, roomIndex) => {
				room.ratePlans.forEach((ratePlan, ratePlanIndex) => {
					const qty = this.selectedOptions[roomIndex][ratePlanIndex];
					if (qty > 0) {
						const taxesFeesAddTotal = ratePlan.payment.taxesFeesAdd.length
							? parseFloat(ratePlan.payment.taxesFeesAdd[0].Total) : 0;
						const taxesFeesDisplayTotal = ratePlan.payment.taxesFeesDisplay.length
							? parseFloat(ratePlan.payment.taxesFeesDisplay[0].Total) : 0;
						selectedRooms.push({
							roomId: room.roomId,
							guestAdults: room.searchedPax.adults,
							guestChildren: room.searchedPax.children,
							roomName: room.roomName,
							selectedQuantity: qty,
							searchCurrency: ratePlan.payment.chargeAmount.searchCurrency,
							currency: ratePlan.payment.chargeAmount.currency,
							commission: ratePlan.payment.chargeAmount.commission,
							totalPrice: ratePlan.payment.chargeAmount.total,
							pricePerRoom: ratePlan.payment.chargeAmount.amount,
							discount: ratePlan.payment.chargeAmount.discount,
							promotion: ratePlan.payment.chargeAmount.promotion,
							data: ratePlan.payment.chargeAmount.data,
							totalTaxesDisplay: taxesFeesDisplayTotal,
							ratePlanCode: ratePlan.code,
							ratePlanId: ratePlan.id,
							ratePlanOptions: ratePlan.options,
							nightlyBreakdown: ratePlan.nightlyBreakdown,
							searchedPax: room.searchedPax
						});
					}
				});
			});
			return selectedRooms;
		},
	},
};
</script>

<style scoped>
.loader {
	border: 4px solid #f3f3f3;
	border-top: 4px solid #3498db;
	border-radius: 50%;
	width: 24px;
	height: 24px;
	animation: spin 1s linear infinite;
	margin: auto;
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}

	100% {
		transform: rotate(360deg);
	}
}

/* invalid helper */
.is-invalid {
	border: 1px solid #dc3545 !important;
	border-radius: .375rem;
}

table thead th {
	background-color: #0F172A;
	color: white;
	font-weight: bold;
	font-size: 16px;
	text-align: center;
}

table {
	width: 100%;
	border-collapse: collapse;
}

th,
td {
	padding: 4px;
	border: 1px solid #ccc;
	text-align: left;
	vertical-align: middle;
}

th:first-child,
td:first-child {
	width: 25%;
}

th:nth-child(2),
td:nth-child(2) {
	width: 10%;
	vertical-align: middle;
	text-align: center;
}

th:nth-child(3),
td:nth-child(3) {
	width: 15%;
	vertical-align: middle;
	text-align: center;
}

td:nth-child(3) ul li {
	text-align: center;
}

th:nth-child(4),
td:nth-child(4) {
	width: 25%;
	vertical-align: middle;
}

th:nth-child(5),
td:nth-child(5) {
	width: 10%;
	text-align: center;
	vertical-align: middle;
}

th:last-child,
td:last-child {
	width: 15%;
	border: none;
	vertical-align: top;
}

.center-data {
	justify-content: space-between;
	flex-direction: column;
	display: flex;
	height: fit-content;
}

.list-prices {
	list-style-type: none;
	padding: 0;
	margin: 0;
}

.list-prices>li {
	padding: 10px 0;
	border-bottom: 1px solid #ddd;
	align-items: center;
	min-height: 16vh;
}

.list-prices li:last-child {
	border: none;
}

button {
	background-color: #0F172A;
	color: #fff;
	border: none;
	padding: 10px 20px;
	cursor: pointer;
	border-radius: 4px;
}

button:hover {
	background-color: #0f172ab8;
	transform: scale(1.03);
}

tr {
	min-height: 50px;
}

option:disabled {
	color: gray;
	background-color: #f0f0f0;
}

.gallery__img {
	height: 100%;
	margin: 0 auto 20px;
}

.gallery__item-img {
	width: 90%;
	height: 120px;
	object-fit: cover;
	cursor: pointer;
	border: 2px solid transparent;
	transition: border-color 0.3s ease-in-out;
	margin-bottom: 20px;
}

.gallery__item-img:hover,
.gallery__item--is-acitve .gallery__item-img {
	border-color: #007bff;
}



.modal-overlay {
	position: fixed;
	inset: 0;
	background: rgba(0, 0, 0, .6);
	z-index: 1080;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 16px;
}

.modal-content {
	width: 100%;
	max-width: 100%;
	max-height: 90vh;
	background: #fff;
	border-radius: 12px;
	overflow: hidden;
	display: flex;
	flex-direction: column;
}

.modal-header {
	position: sticky;
	top: 0;
	z-index: 1;
	background: #fff;
	border-bottom: 1px solid #eee;
}

.modal-body {
	padding: 16px;
	overflow: auto;
}

.close-btn {
	background: var(--coral-red-color);
	color: #fff
}

.swiper-modal {
	width: 100%;
	min-height: 220px;
	background: #fff;
	border-radius: 12px;
}

.swiper-modal .swiper-wrapper {
	align-items: center;
}

.swiper-modal .swiper-slide {
	display: flex;
	align-items: center;
	justify-content: center;
	background: #fff;
}

.swiper-slide-modal {
	height: 100%;
	width: auto;
	max-width: 100%;
	object-fit: contain;
	display: block;
	border-radius: 8px;
	background: #fff;
}

@media (min-width: 576px) {
	.modal-content {
		max-width: 540px;
	}

	.swiper-modal {
		min-height: 280px;
	}
}

@media (min-width: 768px) {
	.modal-content {
		max-width: 720px;
	}

	.swiper-modal {
		min-height: 360px;
	}
}

@media (min-width: 992px) {
	.modal-content {
		max-width: 920px;
	}

	.swiper-modal {
		min-height: 420px;
	}
}

@media (min-width: 1200px) {
	.modal-content {
		max-width: 1040px;
	}

	.swiper-modal {
		min-height: 460px;
	}
}

.reserve-sticky {
	position: sticky;
	top: 100px;
	z-index: 999;
	background: #fff;
	padding: .75rem 1rem;
	border-bottom: 1px solid #e9ecef;
	backdrop-filter: saturate(180%) blur(2px);
}

@media (max-width: 767.98px) {
	.reserve-sticky {
		top: 56px;
	}

	.reserve-sticky .btn {
		width: 100%;
	}
}

.search-button {
	padding: 0 24px;
	font-size: clamp(0.95rem, 2vw, 1.125rem);
	font-weight: 600;
	height: 100%;
	min-height: 92px;
	border-radius: 30px;
}

:deep(.search-button.btn_theme)::before {
	content: none;
}

.search-button:disabled {
	opacity: 0.75;
	cursor: not-allowed;
}

@media (max-width: 767.98px) {
	.search-button {
		width: 100%;
	}
}
</style>
